/* Please add events to this file first:
 * https://docs.google.com/spreadsheets/d/1ybCfEav51tH6XZgK9txb7c1Hb6r6XU3df8mR6iSN38g/edit#gid=1749367034
 */

const EDITOR_ID = 109;
const PRODUCT_ASSIGNMENT_ID = 114;

/**
 * Adds two params together.
 * @param {number} groupId The group id.
 * @param {number} eventIndex The event index.
 * @returns {number} the event id.
 */
const generateEventId = (groupId: number, eventIndex: number): number => {
  return parseInt(groupId + eventIndex.toString().padStart(4, '0'));
};

export const EDITOR_EVENT = {
  VIEWED: generateEventId(EDITOR_ID, 1),
  SAVE_CLICKED: generateEventId(EDITOR_ID, 2),
  PUBLISH_CLICKED: generateEventId(EDITOR_ID, 3),
  GS_TAB_VIEWD: generateEventId(EDITOR_ID, 4),
  GS_CREATE_NEW_PRESET_POPUP_CLICKED: generateEventId(EDITOR_ID, 5),
  GS_CREATE_FROM_LIVE_THEME_CLICKED: generateEventId(EDITOR_ID, 6),
  GS_CREATE_FROM_THIS_PAGE_CLICKED: generateEventId(EDITOR_ID, 7),
  GS_CREATE_NEW_PRESET_CLICKED: generateEventId(EDITOR_ID, 8),
  GS_PRESET_MORE_OPTIONS_CLICKED: generateEventId(EDITOR_ID, 9),
  GS_DUPLICATE_PRESET_CLICKED: generateEventId(EDITOR_ID, 10),
  GS_APPLY_PRESET_MORE_OPTIONS_CLICKED: generateEventId(EDITOR_ID, 11),
  GS_PRESET_DETAIL_VIEWD: generateEventId(EDITOR_ID, 12),
  GS_STYLE_DETAIL_VIEWD: generateEventId(EDITOR_ID, 13),
  GS_UPDATE_BUTTON_CLICKED: generateEventId(EDITOR_ID, 14),
  GS_DISCARD_BUTTON_CLICKED: generateEventId(EDITOR_ID, 15),
  GS_APPLY_PRESET_CLICKED: generateEventId(EDITOR_ID, 16),
  GS_QUICK_NAV_CLICKED: generateEventId(EDITOR_ID, 17),
  GS_CUSTOM_CODE_SAVED: generateEventId(EDITOR_ID, 18),
  AB_TESTING_TIP_CLICKED: generateEventId(EDITOR_ID, 19),
};

export const LIBRARY_MODAL_EVENT = {
  SEARCH_TEMPLATE: 1070005,
  SEARCH_BLOCK: 1100001,
  SEARCH_ELEMENT: 1110001,
  FILTER_TEMPLATE_BY_USE_CASE: 1070006,
  FILTER_BLOCK_BY_USE_CASE: 1100002,
  FILTER_ELEMENT_BY_USE_CASE: 1110002,
  SEARCH_ELEMENT_ON_SIDEBAR: 1110003,
};

export const PRODUCT_ASSIGNMENT_EVENT = {
  CLICK_ASSIGN_BUTTON_TOPBAR: generateEventId(PRODUCT_ASSIGNMENT_ID, 1),
  CLICK_ASSIGN_BUTTON_SIDEBAR: generateEventId(PRODUCT_ASSIGNMENT_ID, 2),
  SELECT_ALL_PRODUCTS: generateEventId(PRODUCT_ASSIGNMENT_ID, 3),
  SELECT_SHOPIFY_COLLECTIONS: generateEventId(PRODUCT_ASSIGNMENT_ID, 4),
  SELECT_PRODUCT_TEMPLATES: generateEventId(PRODUCT_ASSIGNMENT_ID, 5),
  CONFIRM_ASSIGNMENT: generateEventId(PRODUCT_ASSIGNMENT_ID, 6),
  PRODUCT_MODULE_MESSAGE_CLICKED: generateEventId(PRODUCT_ASSIGNMENT_ID, 12),
};

export const SAVE_TO_LIBRARY_EVENT_ID = 1160001;
